import React, { useEffect } from "react";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Newsletter from "../components/Newsletter";
import NewsWidget from "../components/NewsWidget";
import Breadcrumbs from "../components/Breadcrumbs";
import newsList from "../data/news.json";
import NewsCard from "../components/NewsCard";
import StructuredData from "../seo/StructuredData";
import { breadcrumbJsonLd } from "../seo/jsonld";
import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_URL } from "../seo/site";

export default function Press({ setHeader }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const newsArray = Object.values(newsList);
  const pageLang = i18n?.language === "me" ? "me" : "en";
  const pageUrl = `${SITE_URL}${location.pathname}`;
  const pageTitle = `${t("header.press.pageTitle")} - ${SITE_NAME}`;
  const pageDescription = t("header.press.metaDescription");
  const enUrl = `${SITE_URL}/en/news`;
  const meUrl = `${SITE_URL}/me/vijesti`;
  const breadcrumbItems = [
    { name: SITE_NAME, item: `${SITE_URL}/${pageLang}` },
    { name: t("header.press.pageTitle"), item: pageUrl },
  ];
  const newsItemListJsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: newsArray.slice(0, 12).map((news, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url:
        pageLang === "en"
          ? `${SITE_URL}/en/news/${news.path}`
          : `${SITE_URL}/me/vijesti/${news.me_path || news.path}`,
      name: t(news.title),
    })),
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  return (
    <>
      <Helmet htmlAttributes={{ lang: pageLang === "me" ? "sr-ME" : "en" }}>
        {/* <!-- meta tag --> */}
        <meta charSet="utf-8" />
        <title>
          {pageTitle}
        </title>

        {/* <!-- Meta Tags--> */}
        <meta name="description" content={pageDescription} />
        <meta
          name="keywords"
          content="durō, duro, niche perfumery, niche parfimerija,  parfimerija, galerija"
        />
        <meta name="author" content="intellect.se" />
        <link rel="canonical" href={pageUrl} />
        <link rel="alternate" href={enUrl} hrefLang="en" />
        <link rel="alternate" href={meUrl} hrefLang="sr-ME" />
        <link rel="alternate" href={meUrl} hrefLang="x-default" />

        {/* <!-- responsive tag --> */}
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* <!-- Facebook Metadata --> */}
        <meta property="og:type" content="website" />
        <meta property="og:image:height" content="1200" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:url" content={pageUrl} />
        <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
      </Helmet>
      <Loader />
      {/* <!-- Main content Start --> */}
      <div className="main-content">
        {/* <!-- Breadcrumbs Start --> */}
        <div className="rs-breadcrumbs img3">
          <div className="container">
            <div className="breadcrumbs-inner">
              <h1 className="page-title">
                {t("home.news.main")}
                {/*<span className="watermark">{home.news.main}</span>*/}
              </h1>
            </div>
          </div>
        </div>
        <Breadcrumbs bg="light" />
        {/* <!-- Breadcrumbs End --> */}

        {/* <!-- Blog Section Start --> */}
        <div className="rs-inner-blog gray-bg4 pt-120 md-pt-80">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 md-mb-50">
                <div className="row">
                  {newsArray.map((news) => (
                    <NewsCard key={news.title} news={news} />
                  ))}
                </div>
              </div>
              <div className="col-lg-4 col-md-12 pl-35 md-pl-15">
                <div className="widget-area">
                  {/* <!--<div className="search-widget mb-50">
                                    <div className="search-wrap">
                                        <input type="search" placeholder="Searching..." name="s" className="search-input" value="">
                                        <button type="submit" value="Search"><i className="flaticon-search"></i></button>
                                    </div>
                                </div>--> */}
                  <NewsWidget />
                  {/* <!--<div className="categories mb-45">
                                    <div className="widget-title">
                                        <h3 className="title">{t("filters.categories", { defaultValue: "Categories" })}</h3>
                                    </div>
                                    <ul>
                                        <li><Link to="#!">Branding</Link></li>
                                        <li><Link to="#!">Digital Marketing</Link></li>
                                        <li><Link to="#!">E-commerce</Link></li>
                                        <li><Link to="#!">Graphic Design</Link></li>
                                    </ul>
                                </div>--> */}
                  <div className="follow-us">
                    <div className="widget-title mb-40">
                      <h3 className="title">{t("home.news.follow")}</h3>
                    </div>
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/duro.montenegro">
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.twitter.com/DuroCologne">
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/duro_montenegro">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.youtube.com/@duro_montenegro">
                          <i className="fa fa-youtube"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.tiktok.com/@duro_montenegro">
                          <i className="fa-brands fa-tiktok"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Newsletter section start --> */}
          <div className="rs-newsletter style1 pt-120 md-pt-80 mb--65">
            <Newsletter />
          </div>
          {/* <!-- Newsletter section end --> */}
        </div>
        {/* <!-- Blog Section End -->  */}
      </div>
      {/* <!-- Main content End --> */}
      <StructuredData data={[breadcrumbJsonLd(breadcrumbItems), newsItemListJsonLd]} />
    </>
  );
}
